/* Filtrous B2B contextual pricing — LIST VIEWS (v1.13, 2026-08-05).

   Ownership: the PDP price belongs to sections/filtrous-ctx-price.liquid +
   assets/filtrous-ctx-price.js (Liquid emits window.FV3_CTX_PRICE). THIS FILE
   MUST NOT TOUCH .pdp-price — the two used to fight over it. This file owns
   list/sheet rows, search-results rows, and "Pairs with" cards, which render
   from the STATIC catalog-index.json (list prices baked at build time).

   !! NEVER SEND Accept: application/json ON A ?sections= REQUEST !!
   On a /products/<handle> URL that header makes Shopify serve its PRODUCT
   JSON endpoint ({"product":{...}}) and IGNORE ?sections= entirely. The
   session check then found no filtrous-customer-state key, concluded "not
   logged in", and exited before touching anything — so "Pairs with" CARDS
   never got contract prices, while sheet ROWS worked fine because their page
   path is / where no product JSON endpoint exists. Same code, different URL,
   opposite result. Cost most of 2026-08-05 to find (David). Verified: with the
   header -> 3824 bytes of product JSON; without -> 342 bytes, section present.

   Per-customer price source: templates/product.ctxprice.liquid via
   /products/<handle>?view=ctxprice — a REAL page render, so the company
   catalog resolves exactly as it does on the PDP. (The Section Rendering API
   did not reliably carry customer.current_location, so it returned LIST
   price.)

   LAYOUT — rows and cards need DIFFERENT treatments, do not merge them:
     Table rows: the cell stays a table-cell (flexing the <td> collapses the
     Price column 143px -> 52px) and the struck list price is absolutely
     positioned OUT OF FLOW to the left, so the contract price itself stays
     centred on the column line.
     Cards: inline-flex pair, left-aligned like the rest of the card. The
     absolute treatment pushed the struck price outside the ~180px card and it
     was clipped (David 2026-08-05).

   DEBUG: append ?b2bdebug=1 for an on-screen panel (gate result, index size,
   cards found, per-sku why-not). Inert without the flag. STRIP BEFORE
   PUBLISHING to customers.

   Marker discipline: the "already patched" marker lives on the PRICE node, and
   alreadyPatched() also requires .b2b-pair to still be present — the app can
   re-render a card's contents in place, which would strand a container-level
   marker (the v1.5-v1.9 card bug).

   After ANY edit the CDN serves the previous MINIFIED build until the page
   HTML picks up the new ?v= — retest with a FRESH unique query param. */
(function () {
  'use strict';

  var CFG = window.FV3_CONFIG || {};
  var INDEX_URL = CFG.indexUrl || '/catalog-index.json';
  var CTX_VIEW = 'ctxprice';
  var STATE_SECTION = 'filtrous-customer-state';
  var WAS_COLOR = '#5c6f7e';
  var DEBUG = /[?&]b2bdebug=1/.test(location.search);

  var bySku = null;
  var ctxCache = {};
  var scheduled = false;
  var rowObserver = null;

  var diag = [];
  var painted = false;
  function D(k, v) {
    if (!DEBUG) return;
    diag.push([k, String(v)]);
    if (painted) paint(); else setTimeout(paint, 400);
  }
  function paint() {
    if (!DEBUG) return;
    var box = document.getElementById('b2b-diag-panel');
    if (!box) {
      box = document.createElement('div');
      box.id = 'b2b-diag-panel';
      box.setAttribute('style', 'position:fixed;z-index:2147483647;top:8px;right:8px;width:430px;max-height:94vh;overflow:auto;background:#0b2740;color:#e8f6f2;font:12px/1.45 ui-monospace,Menlo,monospace;padding:12px 14px;border-radius:10px;box-shadow:0 10px 40px rgba(0,0,0,.45);');
      document.body.appendChild(box);
      painted = true;
    }
    var html = '<div style="font-weight:700;color:#5fe3c0;margin-bottom:7px">B2B PRICING DIAGNOSTIC</div>';
    for (var i = 0; i < diag.length; i++) {
      html += '<div style="margin:2px 0;word-break:break-word"><span style="color:#9db1bf">' +
        diag[i][0] + ':</span> ' + diag[i][1].replace(/[<>]/g, '') + '</div>';
    }
    box.innerHTML = html;
  }

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function renderNegotiated(priceEl, neg) {
    priceEl.textContent = '';
    priceEl.classList.add('b2b-patched');
    var pair = document.createElement('span');
    pair.className = 'b2b-pair';
    if (neg.listCents != null && neg.listCents !== neg.cents) {
      var was = document.createElement('s');
      was.className = 'b2b-was';
      was.textContent = money(neg.listCents);
      pair.appendChild(was);
    }
    var now = document.createElement('span');
    now.className = 'b2b-now';
    now.textContent = money(neg.cents);
    pair.appendChild(now);
    priceEl.appendChild(pair);
  }

  function alreadyPatched(priceEl, sku) {
    return priceEl.getAttribute('data-b2b-sku') === sku && !!priceEl.querySelector('.b2b-pair');
  }

  function sectionJSON(html, id) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.getElementById(id);
      return node ? JSON.parse(node.textContent) : null;
    } catch (e) { return null; }
  }

  // NOTE: deliberately NO Accept header — see the warning at the top of file.
  function fetchSection(path, section) {
    return fetch(path + '?sections=' + section, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j[section] ? j[section] : null; })
      .catch(function () { return null; });
  }

  function loadIndex() {
    return fetch(INDEX_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        bySku = {};
        (data.products || []).forEach(function (p) {
          if (!p.sku) return;
          var cents = Math.round(parseFloat(p.price) * 100);
          bySku[String(p.sku).toUpperCase()] = { handle: p.handle, listCents: isNaN(cents) ? null : cents };
        });
        D('index skus', Object.keys(bySku).length);
      })
      .catch(function (e) { bySku = {}; D('index LOAD FAILED', e && e.message); });
  }

  function ctxFor(handle) {
    if (!ctxCache[handle]) {
      ctxCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=' + CTX_VIEW, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) D('ctx HTTP ' + handle, r.status); return r.ok ? r.text() : null; })
        .then(function (txt) {
          if (!txt) return null;
          var d;
          try { d = JSON.parse(txt); }
          catch (e) { D('ctx NOT JSON ' + handle, txt.length + ' chars: ' + txt.slice(0, 50)); return null; }
          D('ctx ' + handle, 'logged_in=' + d.logged_in + ' catalog=' + d.catalog_context);
          if (!d || !d.logged_in || !d.variants) return null;
          var map = {};
          d.variants.forEach(function (v) {
            if (v.sku != null && typeof v.cents === 'number') map[String(v.sku).toUpperCase()] = v.cents;
          });
          return map;
        })
        .catch(function (e) { D('ctx FETCH FAILED ' + handle, e && e.message); return null; });
    }
    return ctxCache[handle];
  }

  function negotiatedFor(sku, why) {
    var entry = bySku && bySku[sku];
    if (!entry || !entry.handle) { if (why) D(why + ' ' + sku, 'NOT IN INDEX'); return Promise.resolve(null); }
    return ctxFor(entry.handle).then(function (map) {
      if (!map) { if (why) D(why + ' ' + sku, 'no ctx data'); return null; }
      if (!(sku in map)) { if (why) D(why + ' ' + sku, 'sku absent from ctx response'); return null; }
      var cents = map[sku];
      if (entry.listCents != null && cents === entry.listCents) {
        if (why) D(why + ' ' + sku, 'ctx == list (' + cents + ')');
        return null;
      }
      if (why) D(why + ' ' + sku, 'SWAP ' + entry.listCents + ' -> ' + cents);
      return { cents: cents, listCents: entry.listCents };
    });
  }

  function patchCards() {
    var cards = document.querySelectorAll('#fv3-app .fv3-pcard');
    if (DEBUG) D('cards found', cards.length);
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var skuEl = card.querySelector('.pc-sku b');
        var priceEl = card.querySelector('.pc-p');
        if (!skuEl || !priceEl) return;
        var sku = skuEl.textContent.trim().toUpperCase();
        if (!sku || alreadyPatched(priceEl, sku)) return;
        priceEl.setAttribute('data-b2b-sku', sku);
        negotiatedFor(sku, 'card').then(function (neg) {
          if (!neg || !priceEl.isConnected) return;
          renderNegotiated(priceEl, neg);
          D('card ' + sku, 'PATCHED');
        });
      })(cards[i]);
    }
  }

  function rowSku(row) {
    var s = row.getAttribute('data-sku');
    if (!s) {
      var part = row.querySelector('.fv3-part');
      s = part ? part.textContent : '';
    }
    return (s || '').trim().toUpperCase();
  }

  function patchRow(row) {
    var sku = rowSku(row);
    var priceEl = row.querySelector('.fv3-price');
    if (!sku || !priceEl) return;
    if (alreadyPatched(priceEl, sku)) return;
    priceEl.setAttribute('data-b2b-sku', sku);
    negotiatedFor(sku).then(function (neg) {
      if (!neg || !priceEl.isConnected) return;
      renderNegotiated(priceEl, neg);
    });
  }

  function patchRows() {
    var candidates = document.querySelectorAll('#fv3-app tr');
    var rows = [];
    for (var c = 0; c < candidates.length; c++) {
      if (candidates[c].querySelector('.fv3-price') && rowSku(candidates[c])) rows.push(candidates[c]);
    }
    if (!rows.length) return;
    if ('IntersectionObserver' in window) {
      if (!rowObserver) {
        rowObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            rowObserver.unobserve(entry.target);
            patchRow(entry.target);
          });
        }, { rootMargin: '300px 0px' });
      }
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].getAttribute('data-b2b-seen')) continue;
        rows[i].setAttribute('data-b2b-seen', '1');
        rowObserver.observe(rows[i]);
      }
    } else {
      for (var j = 0; j < rows.length; j++) patchRow(rows[j]);
    }
  }

  function patch() {
    scheduled = false;
    patchCards();
    patchRows();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(patch);
  }

  function injectCSS() {
    var css = document.createElement('style');
    css.textContent =
      // shared type for both surfaces
      '#fv3-app .b2b-was{font-weight:500;font-size:.9em;color:' + WAS_COLOR + ';text-decoration-color:' + WAS_COLOR + ';white-space:nowrap;}' +
      '#fv3-app .b2b-now{white-space:nowrap;}' +
      // TABLE ROWS: contract price centred on the column line, struck price out of flow.
      '#fv3-app td.fv3-price.b2b-patched{text-align:center;}' +
      '#fv3-app td.fv3-price .b2b-pair{position:relative;display:inline-block;}' +
      '#fv3-app td.fv3-price .b2b-was{position:absolute;right:100%;top:0;margin-right:8px;}' +
      // CARDS: inline, left-aligned with the rest of the card. Absolute here
      // pushed the struck price outside the card and it was clipped.
      '#fv3-app .pc-p .b2b-pair{display:inline-flex;align-items:baseline;gap:8px;max-width:100%;flex-wrap:wrap;}';
    document.head.appendChild(css);
  }

  function boot() {
    var mount = document.getElementById('fv3-app');
    D('page', location.pathname);
    D('#fv3-app', !!mount);
    if (!mount) return;
    fetchSection(location.pathname, STATE_SECTION).then(function (html) {
      var state = html && sectionJSON(html, 'fn-customer-state');
      D('gate logged_in', state ? state.logged_in : 'no state');
      D('gate company', state ? state.company : '-');
      if (!state || !state.logged_in) { D('RESULT', 'GATE CLOSED - nothing patches'); return; }
      injectCSS();
      loadIndex().then(function () {
        patch();
        new MutationObserver(schedule).observe(mount, { childList: true, subtree: true });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
